import DatePicker from "../../components/DatePicker";
import { useForm, useWatch } from "react-hook-form";
import ShowAlert from "../../utility/Alert";
import axios from "axios";
import "../WelcomeScreen.css"
import "./productSearch.css"
import * as XLSX from "xlsx";

import "react-toastify/dist/ReactToastify.css"; // Import styles
import { FaDownload } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import SelectInput from "../../components/SelectInput";
import { api_url } from "../../apiconfig/authService";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import LoadingOverlay from "../../components/LoadingCompont/Loading";

const currentDate = new Date();
currentDate.setHours(0, 0, 0, 0);

const ProductNav = () => {
    const [loading, setLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [startDate, setStartDate] = useState(currentDate)
    const [lastDate, setLastDate] = useState(currentDate)
    const [userInfoList, setUserInfoList] = useState([])
    const [sessionByUserList, setSessionByUserList] = useState([])
    const [selectedUserSessions, setSelectedUserSessions] = useState(null)
    const [showPhoneNolist, setShowPhoneNoList] = useState(false)
    const [showSessionlist, setSessionList] = useState(false)
    const dropdownRef = useRef(null);
    const sessionRef = useRef(null)
    const [selectedPhoneNo, setSelectedPhoneNo] = useState(null);
    const [selectedSessionNo, setSelectedSessionNo] = useState(null);
    const [actualData, setActualData] = useState(null)
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm();


    const userType = useWatch({
        control,
        name: "userType",
    });




    useEffect(() => {
        const fetchData = async () => {
            setSelectedPhoneNo(null)
            setSelectedSessionNo(null)
            setLoading(true); // Start loading
            try {
                if (userType) {
                    const res = await axios.get(`${api_url}/utm/screen-navigation-userInfo?startDate=${startDate}&endDate=${lastDate}&userType=${userType}`)

                    setActualData(res?.data?.data)

                    if (userType === "User") {
                        setUserInfoList(res?.data?.data?.users)
                        setSessionByUserList(res?.data?.data?.sessionsByUser)
                    }
                    else if (userType === "Guest") {
                        setSelectedUserSessions(res?.data?.data?.sessionIds)
                    }
                }
            }
            catch (e) {
                console.log(e.response.data.message)
                ShowAlert("error", e.response?.data?.message)
            } finally {
                setLoading(false); // Stop loading regardless of success/error
            }
        }
        fetchData()
    }, [userType, startDate, lastDate]);


    const handleSelect = (curr) => {
        setSelectedPhoneNo(curr.customerphone);
        setSelectedSessionNo(null)
        setSelectedUserSessions(sessionByUserList[curr._id]?.sessions)
        setShowPhoneNoList(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowPhoneNoList(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sessionRef.current && !sessionRef.current.contains(event.target)) {
                setSessionList(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const submitinfo = (data) => {
        console.log("data", data)
    }


    const handleSelectSession = (currSession) => {
        if (userType === "User") {
            setSelectedSessionNo(currSession.sessionId)
            setSessionList(false)
        } else {
            setSelectedSessionNo(currSession)
            setSessionList(false)
        }
    }


    const handleExcel = async () => {

        if (userType === "User" && selectedSessionNo) {

            if (!actualData.NavigationBySession[selectedSessionNo]) {
                setSelectedSessionNo(null)
                return
            }
            try {
                const res = await axios.get(`${api_url}/utm/getSession/${selectedSessionNo}`);
                const sessionProductSearch = actualData.NavigationBySession[selectedSessionNo];
                // Extract session data
                const sessionData = res.data.userSession;

                const excelData = sessionProductSearch.navigation.map((search, index) => ({
                    userid: sessionData.userId._id,
                    UserName: sessionData.userId.name || "",
                    pageTrack: search?.pageTrack.join(", ") || "",
                    devicetype: sessionData.deviceInfo.deviceType,
                    deviceid: sessionData.deviceInfo.deviceId,
                    logintype: sessionData.loginType,
                    clickdatetime: search.createdAt || new Date().toISOString(),
                    locationtype: sessionData.locationType,
                    location: sessionData.location,
                    pincode: sessionData.pincode,
                    sessionid: sessionData.sessionId
                }));

                // Create workbook and worksheet
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);

                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "Session Data");

                // Generate file name with session ID and current date
                const fileName = `ProductNav_Session_${sessionData.sessionId}_Data_from_${new Date(startDate).toLocaleDateString()}_to_${new Date(lastDate).toLocaleDateString()}.xlsx`;

                // Download the file
                XLSX.writeFile(wb, fileName);

            } catch (error) {
                console.error("Error generating Excel file:", error);
            }
        }
        else if (userType === "Guest" && selectedSessionNo) {
            if (!actualData.navigationBySession[selectedSessionNo]) {
                setSelectedSessionNo(null)
                return
            }
            try {
                const res = await axios.get(`${api_url}/utm/getSession/${selectedSessionNo}`);
                const sessionProductSearch = actualData.navigationBySession[selectedSessionNo];

                const sessionData = res.data.userSession;

                const excelData = sessionProductSearch.navigation.map((search, index) => ({
                    UserName: sessionData?.userId?.name || "Guest",
                    pageTrack: search?.pageTrack.join(", ") || "",
                    devicetype: sessionData?.deviceInfo?.deviceType || "",
                    deviceid: sessionData?.deviceInfo?.deviceId || "",
                    logintype: sessionData?.loginType || "",
                    clickdatetime: search?.createdAt || new Date().toISOString(),
                    locationtype: sessionData?.locationType || "",
                    location: sessionData?.location || "",
                    pincode: sessionData?.pincode || "",
                    sessionid: sessionData.sessionId || ""
                }));

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "Session Data");

                const fileName = `ProductNav_Session_${sessionData.sessionId}_Data_from_${new Date(startDate).toLocaleDateString()}_to_${new Date(lastDate).toLocaleDateString()}.xlsx`;


                XLSX.writeFile(wb, fileName);

            } catch (error) {
                console.error("Error generating Excel file:", error);
                // Handle error appropriately
            }
        }
        else {
            try {
                const excelData = [];

                const sessions = actualData;

                for (const [sessionId, sessionInfo] of Object.entries(sessions)) {

                    const sessionData = sessionInfo?.SesstionData || {};  // spelling matches your JSON

                    const sessionBaseData = {
                        sessionid: sessionData?.sessionId || "",
                        userid: sessionData?.userId?._id || "Guest",
                        UserName: sessionData?.userId?.name || "Guest",
                        devicetype: sessionData?.deviceInfo?.deviceType || "",
                        deviceid: sessionData?.deviceInfo?.deviceId || "",
                        logintype: sessionData?.loginType || "",
                        locationtype: sessionData?.locationType || "",
                        location: sessionData?.location || "",
                        pincode: sessionData?.pincode || "",
                    };

                    const searches = sessionInfo?.ScreenNavigation || [];

                    if (searches.length > 0) {
                        for (const search of searches) {
                            excelData.push({
                                ...sessionBaseData,
                                pageTrack: search?.pageTrack.join(", ") || "",
                            });
                        }
                    } else {
                        excelData.push({
                            ...sessionBaseData,
                           pageTrack:" "
                        });
                    }
                }

                if (excelData.length === 0) {
                    console.warn("No data found to export.");
                    return;
                }

                // Create workbook and worksheet
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "Session Data");

                const fileName = `Navigation_info_All_Sessions_Data_from_${new Date(startDate).toLocaleDateString()}_to_${new Date(lastDate).toLocaleDateString()}.xlsx`;

                XLSX.writeFile(wb, fileName);
            } catch (error) {
                console.error("Error generating Excel file:", error);
            }
        }
    };


    return (
        <div className="heading-input">
            <LoadingOverlay isLoading={loading || excelLoading}
                message={excelLoading ? "Generating Excel..." : "Loading data..."} />
            <h2 className="section-heading">Product Navigation Data</h2>
            <form onSubmit={handleSubmit(submitinfo)}>
                <table className="content-style">
                    <tbody>
                        <tr>
                            <td className="font-semibold labelName">Start Date:</td>
                            <td className="p-2">
                                <DatePicker handleDateChange={setStartDate} currentDate={startDate} />
                            </td>
                        </tr>

                        <tr>
                            <td className="p-2 font-semibold labelName">End Date:</td>
                            <td className="p-2">
                                <DatePicker handleDateChange={setLastDate} currentDate={lastDate} />
                            </td>
                        </tr>

                        <tr>
                            <td className="p-2 font-semibold labelName">User Type:</td>
                            <td className="p-2">
                                <SelectInput control={control} name="userType" required={true} option={["All","Guest", "User"]} />
                            </td>
                        </tr>

                        {userType === "User" && userInfoList.length > 0 && (
                            <tr>
                                <td className="p-2 labelName" >Phone No </td>
                                <td className="p-2">
                                    <div className="phone-selector-container" ref={dropdownRef}>
                                        <div
                                            className="phone-selector-toggle"
                                            style={{
                                                background: "white",
                                                color: "black",
                                                padding: "5px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: "8px",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd",
                                                cursor: "pointer",
                                                minWidth: "120px",
                                                userSelect: "none",
                                                paddingLeft: "12px",
                                            }}
                                            onClick={() => setShowPhoneNoList(!showPhoneNolist)}
                                        >
                                            <p style={{ margin: 0, color: '#6b7280' }}>{selectedPhoneNo || "Select No"}</p>
                                            <MdOutlineKeyboardArrowDown style={{
                                                transition: "transform 0.2s",
                                                transform: showPhoneNolist ? "rotate(180deg)" : "rotate(0deg)"
                                            }} />
                                        </div>
                                        {showPhoneNolist && (
                                            <ul
                                                className="phone-selector-dropdown"
                                                style={{
                                                    width: "100%",
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    right: 0,
                                                    backgroundColor: "white",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "4px",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    zIndex: 1000,
                                                    marginTop: "4px",
                                                    listStyle: "none",
                                                    color: "gray",
                                                    paddingLeft: "8px"
                                                }}
                                            >
                                                {userInfoList.map((curr, i) => (
                                                    <li
                                                        key={i}
                                                        onClick={() => {
                                                            handleSelect(curr);
                                                            setShowPhoneNoList(false); // Close dropdown after selection
                                                        }}
                                                        style={{
                                                            padding: "4px 0px",
                                                            cursor: "pointer",
                                                            transition: "background-color 0.2s",
                                                            ":hover": {
                                                                backgroundColor: "#f5f5f5"
                                                            }
                                                        }}
                                                    >
                                                        <FaPhoneAlt style={{ marginRight: "10px" }} />
                                                        {curr.customerphone}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )}

                        {selectedUserSessions !== null && selectedUserSessions !== undefined &&
                            <tr>
                                <td className="p-2 labelName">Session:</td>
                                <td className="p-2">
                                    <div className="phone-selector-container" ref={sessionRef} >
                                        <div
                                            className="phone-selector-toggle"
                                            onClick={() => setSessionList(!showSessionlist)}
                                            style={{
                                                background: "white",
                                                color: "black",
                                                padding: "5px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                borderRadius: "4px",
                                                border: "1px solid #ddd",
                                                cursor: "pointer",
                                                width: "100%",
                                                textWrap: "wrap",
                                                userSelect: "none",
                                            }}
                                        >
                                            <p style={{ margin: 0, color: '#6b7280' }}>{selectedSessionNo || "Select Session"}</p>
                                            <MdOutlineKeyboardArrowDown style={{
                                                transition: "transform 0.2s",
                                                transform: showSessionlist ? "rotate(180deg)" : "rotate(0deg)"
                                            }} />
                                        </div>
                                        {showSessionlist && (
                                            <ul
                                                className="session-selector-dropdown"
                                                style={{
                                                    position: "absolute",
                                                    maxHeight: "200px", // Increased for better visibility
                                                    overflowY: "auto",
                                                    width: "100%",
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: "6px",
                                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                                    padding: "4px 0",
                                                    margin: "4px 0 0 0",
                                                    listStyle: "none",
                                                    zIndex: 1000
                                                }}
                                            >
                                                {selectedUserSessions.map((curr, i) => (
                                                    <li
                                                        key={i}
                                                        onClick={() => handleSelectSession(curr)}
                                                        style={{
                                                            padding: "8px 12px",
                                                            backgroundColor: "#ffffff", // Default background
                                                            color: '#6b7280',
                                                            cursor: "pointer",
                                                            transition: "background-color 0.2s ease",
                                                            borderBottom: "1px solid #f0f0f0", // Separator
                                                            ":hover": {
                                                                backgroundColor: "#f5f5f5", // Hover state
                                                            },
                                                            ":last-child": {
                                                                borderBottom: "none" // Remove border from last item
                                                            }
                                                        }}
                                                    >
                                                        {userType === "User" ? curr.sessionId : curr}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </td>
                            </tr>}
                    </tbody>
                </table>
            </form>
            {(userType === "All" || selectedSessionNo) && <div className="p-2 text-center">
                <button
                    className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                    onClick={() => handleExcel()}
                >
                    <FaDownload className="inline mr-2" />
                    Download Excel
                </button>
            </div>}
        </div>
    )
}

export default ProductNav